import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import FsCaption from 'ui-elements/typography/FsCaption';
import { styles } from './FsDialogTitle.style';

interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const FsDialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <FsCaption className={classes.headline}>{children}</FsCaption>
      {onClose ? (
        <IconButton
          size="small"
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseRoundedIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default FsDialogTitle;
